import { jsx as _jsx } from "react/jsx-runtime";
import { memo } from 'react';
import { ErrorBoundary } from 'shared/components/error-boundary';
import { useSkeleton } from '../skeleton/hook';
export const LazyTab = memo(function LazyTab(props) {
    const { tabKey, active, render } = props;
    const Skeleton = useSkeleton(tabKey, active);
    const R = render;
    return (_jsx(ErrorBoundary, { children: _jsx(Skeleton, { children: _jsx(R, { ...props }) }) }));
});
